// assets/read-more.js
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.rich-text-toggle-section').forEach(function(section) {
    const btn     = section.querySelector('.read-more-toggle-btn');
    const preview = section.querySelector('.read-more-preview');
    const full    = section.querySelector('.read-more-full');

    btn.addEventListener('click', function() {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      if (expanded) {
        preview.style.display = '';
        full.style.display    = 'none';
        btn.textContent       = 'Read more';
        btn.setAttribute('aria-expanded', 'false');
      } else {
        preview.style.display = 'none';
        full.style.display    = '';
        btn.textContent       = 'Read less';
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });
});
